<script type="text/javascript">
	import { Item,Text } from '@smui/list';
	import { get,writable } from "svelte/store";
	import Analytics from "../../Analytics/Analytics";
	import AuthStore from "../../Auth/Store";
	import User from "../../Branding/User";
	
	export let name = "Menu Item";
	export let requiresFeature = "";		// Feature
	export let icon = ""; 					// mapboxgl-ctrl-geollect-ICONNAME
	export let materialIcon = "";
	export let materialIconOutlined = false;
	export let visible = writable(false); 	// must be a writable.
	export let togglable = true;
	export let onclick = null

	let loginState = AuthStore.meta.state;
	let canShow = false;
	$: {
		$loginState;
		canShow = requiresFeature.length === 0 || User.hasFeature(requiresFeature);
	}

	let doToggle = (writableBool) => {
		if (togglable) {
			writableBool.set(!get(writableBool));
		}
		if (get(writableBool)) {
			Analytics.event("open", { category: name, username: get(AuthStore.userInfo).username });
		}
		if (onclick) {
			onclick();
		}
	}

</script>

{#if canShow}
	<Item on:SMUI:action={()=>{ doToggle(visible); }}>
		{#if icon.length > 0}
			<div class={"list-item-icon mapboxgl-ctrl-geollect-" + icon} class:opacity-full={$visible} class:opacity-half={!$visible}></div>
		{/if}
		{#if materialIcon.length > 0}
			<div class={"list-item-icon " + ((materialIconOutlined)?"material-icons-outlined":"material-icons")} class:opacity-full={$visible} class:opacity-half={!$visible}>{materialIcon}</div>
		{/if}

		<Text><span class:opacity-full={$visible} class:opacity-half={!$visible}>{name}</span></Text>
		<div class="list-item-icon-right material-icons" class:opacity-full={$visible} class:opacity-half={!$visible}>
			{#if $visible}visibility{:else}visibility_off{/if}
		</div>
	</Item>
{/if}
